(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('FaqController', FaqController);

    FaqController.$inject = ['DataUtils', 'Faq'];

    function FaqController(DataUtils, Faq) {

        var vm = this;

        vm.faqsInUz = [];
        vm.faqsInEn = [];
        vm.faqsInRu = [];
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll() {
            Faq.query({
                lang: 'uz',
            }, function (result) {
                vm.faqsInUz = result;
            });

            Faq.query({
                lang: 'en',
            }, function (result) {
                vm.faqsInEn = result;
            });

            Faq.query({
                lang: 'ru',
            }, function (result) {
                vm.faqsInRu = result;
            });
        }
    }
})();
